import React from 'react';
import { Link } from 'react-router-dom';

interface ProjectDetailsProps {
  name: string;
  description: string;
  mainLink: string;
  externalUrl?: string | null;
}

const ProjectDetails: React.FC<ProjectDetailsProps> = ({ name, description, mainLink, externalUrl }) => {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-sc-blue/20 via-sc-dark/90 to-sc-mint/20 text-white flex flex-col items-center justify-start px-4 py-20">
      <h1 className="text-5xl font-extrabold mb-6 text-gradient text-center">{name}</h1>
      <p className="text-xl text-gray-300 mb-8 max-w-2xl text-center">{description}</p>
      <div className="flex flex-col md:flex-row gap-4">
        <Link
          to={mainLink}
          className="px-10 py-4 bg-gradient-to-r from-sc-blue via-sc-mint to-sc-violet text-black text-xl font-bold rounded-full shadow-lg animate-pulse-glow hover:animate-none transition"
        >
          Go to {name} Page
        </Link>
        {externalUrl && (
          <a
            href={externalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-4 bg-gradient-to-r from-sc-violet via-sc-blue to-sc-mint text-black text-xl font-bold rounded-full shadow-lg hover:scale-105 transition"
          >
            Go to {name} (External)
          </a>
        )}
      </div>
    </div>
  );
};

export default ProjectDetails;
